/* VexaFit — interacciones propias (prefijo vx-) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.vx-reveal:not(.vx-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vx-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vx-visible');
        if (e.target.hasAttribute('data-vx-count')) countUp(e.target);
        e.target.querySelectorAll('[data-vx-count]').forEach(countUp);
        io.unobserve(e.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    if (el.dataset.vxDone) return;
    el.dataset.vxDone = '1';
    var raw = el.getAttribute('data-vx-count') || el.textContent;
    var target = parseFloat(String(raw).replace(',', '.'));
    if (isNaN(target) || reduce) return;
    var decimals = (String(raw).split(/[.,]/)[1] || '').length;
    var comma = String(raw).indexOf(',') > -1;
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = (target * eased).toFixed(decimals);
      el.textContent = comma ? v.replace('.', ',') : v;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    setTimeout(function () { el.textContent = raw; }, dur + 400);
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-vx-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var k = (parseFloat(img.getAttribute('data-vx-parallax')) || 0) / 100;
        var p = Math.min(Math.max((window.innerHeight - r.top) / (window.innerHeight + r.height), 0), 1);
        var off = (p - 0.5) * k * r.height;
        img.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(' + (1 + k * 1.2).toFixed(3) + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (fmt || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  function initProducto() {
    document.querySelectorAll('[data-vx-pdp]').forEach(function (root) {
      var main = root.querySelector('[data-vx-main]');
      var thumbs = root.querySelectorAll('[data-vx-thumb]');
      function show(btn) {
        if (!btn || !main) return;
        main.style.opacity = 0;
        setTimeout(function () {
          main.src = btn.getAttribute('data-src');
          main.srcset = '';
          main.alt = btn.getAttribute('data-alt') || '';
          main.style.opacity = 1;
        }, 180);
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === btn ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });

      var qty = root.querySelector('[data-vx-qty]');
      root.querySelectorAll('[data-vx-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          n += parseInt(b.getAttribute('data-vx-qty-btn'), 10);
          qty.value = Math.max(1, n);
        });
      });

      var dataEl = root.querySelector('[data-vx-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var fmt = root.getAttribute('data-money-format');
      var idInput = root.querySelector('input[name="id"]');
      var priceNow = root.querySelectorAll('[data-vx-price]');
      var priceOld = root.querySelector('[data-vx-compare]');
      var badge = root.querySelector('[data-vx-badge]');
      var buttons = root.querySelectorAll('[data-vx-add]');
      var addLabel = root.getAttribute('data-add-label');
      var soldLabel = root.getAttribute('data-sold-label');

      function current() {
        var sel = [];
        root.querySelectorAll('[data-vx-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-vx-option-value]');
          if (lbl && c) lbl.textContent = c.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
      }

      root.addEventListener('change', function (e) {
        if (!e.target.closest('[data-vx-option]')) return;
        var v = current();
        if (!v) {
          buttons.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = soldLabel; });
          return;
        }
        idInput.value = v.id;
        priceNow.forEach(function (p) { p.textContent = money(v.price, fmt); });
        if (priceOld) {
          var sale = v.compare_at_price && v.compare_at_price > v.price;
          priceOld.textContent = sale ? money(v.compare_at_price, fmt) : '';
          priceOld.hidden = !sale;
          if (badge) badge.hidden = !sale;
        }
        buttons.forEach(function (b) {
          b.disabled = !v.available;
          b.querySelector('span').textContent = v.available ? addLabel : soldLabel;
        });
        if (v.featured_media) {
          var t = root.querySelector('[data-vx-thumb][data-media-id="' + v.featured_media.id + '"]');
          if (t) show(t);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });

      var bar = document.querySelector('[data-vx-sticky-bar]');
      var form = root.querySelector('.vx-buy__form');
      if (bar && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          bar.classList.toggle('vx-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(form);
        var sb = bar.querySelector('[data-vx-add]');
        if (sb) sb.addEventListener('click', function (e) {
          e.preventDefault();
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    });
  }

  function init() {
    initReveal();
    initParallax();
    initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', initReveal);
})();
